import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: #282c34;
  border-radius: 15px;
`;
